<template>
  <div>
    <form
      ref="form"
      id="form_id"
      class="row g-3 needs-validation"
      novalidate
      @submit.prevent="check"
    >
      <div
        class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <div class="row">
          <div class="col-10">
            <h1 class="h2 text-muted">RATING ENGINE / ADD CALCULATOR</h1>
          </div>

          <div class="col-1">
            <button
              type="button"
              class="btn btn-danger"
              id="disbut"
              @click="discard"
            >
              Discard
            </button>
          </div>
          <div class="col-1">
            <button class="btn btn-primary" type="submit" id="savebut">
              Save
            </button>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger" role="alert">
        Error: {{ reason }}
      </div>
      <div class="col-md-7">
        <label class="form-label">Calculator Name</label>
        <input class="form-control" v-model="calculator_name" required />
        <div class="invalid-feedback">
          Calculator Name is required!
        </div>
      </div>
      <div class="col-md-5">
        <label class="form-label">Insurer</label>
        <select class="form-select" v-model="insurer_id" required>
          <option
            v-for="insurer in insurers"
            v-bind:value="insurer.insurer_id"
            :key="insurer.insurer_id"
          >
            {{ insurer.insurer_name }}
          </option>
        </select>
        <div class="invalid-feedback">
          Insurer is required!
        </div>
      </div>
      <div class="col-md-12">
        <label class="form-label">Description / Notes</label>
        <textarea
          class="form-control"
          rows="4"
          v-model="calculator_desc"
        ></textarea>
      </div>
      <div class="col-md-7">
        <label for="url" class="form-label">Quote Endpoint</label>
        <input
          class="form-control"
          id="url"
          v-model="api_route"
          autocomplete="nope"
          required
        />
        <div class="invalid-feedback">
          Quote Endpoint is required!
        </div>
      </div>
      <div class="col-md-7">
        <label for="params" class="form-label">Parameters Endpoint</label>
        <input
          class="form-control"
          id="params"
          autocomplete="nope"
          v-model="params_route"
          required
        />
        <div class="invalid-feedback">
          Parameters Endpoint is required!
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import config from "../../config";
export default {
  data() {
    return {
      calculator_name: "",
      calculator_desc: "",
      insurers: [],
      insurer_id: "",
      api_route: "",
      error: false,
      params_route: "",
      reason: "",
    };
  },
  methods: {
    async check() {
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_id: this.insurer_id,
              calculator_name: this.calculator_name,
              description: this.calculator_desc,
              api_route: this.api_route,
              params_route: this.params_route,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/add_calculator",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) this.$router.push("/calculators");
        else {
          this.error = true;
          this.reason = data["reason"];
        }
      }
    },
    discard() {
      this.$router.push("/calculators");
    },
  },
  async mounted() {
    const res = await fetch(config.baseURL + "/get_insurers", {
      credentials: "include",
    });
    const data = await res.json();
    this.insurers = data;
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
  },
};
</script>

<style scoped></style>
